import { render, staticRenderFns } from "./AlleBewijzen.vue?vue&type=template&id=08cbf599&scoped=true"
import script from "./AlleBewijzen.vue?vue&type=script&lang=js"
export * from "./AlleBewijzen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cbf599",
  null
  
)

export default component.exports